<template>
    <product-overview id="AE_overview" title="Group Accident Expense Insurance" :ctaLink="`/${$route.params.id}/accident-expense`">
        <template v-slot:video>
            <accident-expense-video />
        </template>
        <p><strong>Group Accident Expense</strong> insurance <strong>pays a benefit directly to you</strong> when you
        receive treatment from a physician for a covered accident.</p>
        <template v-slot:key-features>
            <key-feature-bullet>
                <strong>Helps with out-of-pocket expenses</strong> associated with covered accidents
            </key-feature-bullet>
            <key-feature-bullet>
                <strong>No deductibles,</strong> copays, coinsurance or networks - see any doctor
            </key-feature-bullet>
            <key-feature-bullet v-if="product[0]['AEUnderwritingBasis.GMC'] === 'Guaranteed Issue'">
                <strong>Guaranteed issue</strong> – no medical exams or tests
            </key-feature-bullet>
            <key-feature-bullet>
                <strong>Portable</strong> – coverage continues if you retire or change jobs, as long as you pay the premiums
            </key-feature-bullet>
        </template>
    </product-overview>
</template>
<script>
import { mapGetters } from 'vuex'
import ProductOverview from './product-overview'
import { AccidentExpenseVideo } from '@/components/videos'
import KeyFeatureBullet from '@/components/key-feature-bullet'
export default {
    components: {
        ProductOverview,
        AccidentExpenseVideo,
        KeyFeatureBullet
    },
    data(){
        return {
        }
    },
    mounted(){

    },
    computed: {
        ...mapGetters({
            proposalId: 'getProposalId',
            product: 'getAccidentExpense',
            employer: 'getEmployer',
            agent: 'getAgent'
        })    
    },
    methods: {
    }
}
</script>
<style lang="scss" scoped>

</style>
